(function () {
  'use strict';

  /* ===== НАЛАШТУВАННЯ ===== */
  const STORAGE_KEY = 'shopify_wishlist';   // масив product handles (той самий, що в основному wishlist.js)
  const ES_READY_TIMEOUT = 10000;           // скільки чекаємо на eS.js, мс
  /* ========================
     siteId / sc / webId / orgId / datetime / referrer / s_location
     НЕ потрібні тут — їх додає сам eS.js (як для ProductPage/CategoryPage).
     Вимога зі сторони eS.js: у тему перед </body> має стояти скрипт eS
     з тим самим store id, і в eS('init', {...}) — TRACKING:false, якщо
     всі події шлються методом es.JS API.
     ======================== */

  /* ---- чекаємо, поки підвантажиться eS.js (той, що вже шле ProductPage/CategoryPage) ---- */
  function whenESReady(cb) {
    if (typeof window.eS === 'function') { cb(); return; }
    const started = Date.now();
    const t = setInterval(function () {
      if (typeof window.eS === 'function') {
        clearInterval(t);
        cb();
      } else if (Date.now() - started > ES_READY_TIMEOUT) {
        clearInterval(t);
        console.warn('[eSputnik wishlist] eS.js не знайдено — подія AddToWishlist не піде');
      }
    }, 200);
  }

  /* ---- дані залогіненого клієнта (опційно, для матчінгу контакту) ----
     У тему, всередині {% if customer %}:
     <script>window.__esCustomer = {
       email: "{{ customer.email }}",
       externalId: "{{ customer.id }}",
       phone: "{{ customer.phone }}"
     };</script>
     Якщо нема — нічого не передаємо, контакт зматчиться по cookie sc. */
  function customerGeneralInfo() {
    const c = window.__esCustomer || {};
    const gi = {};
    if (c.email)      gi.user_email = c.email;
    if (c.phone)      gi.user_phone = String(c.phone);
    if (c.externalId) gi.externalCustomerId = String(c.externalId);
    return gi;
  }

  /* ---- дані товару за handle (variant_id = productKey = g:id у фіді) ---- */
  const cache = new Map();
  async function fetchProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);
    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('not found');
      const data = await res.json();
      cache.set(handle, data);
      return data;
    } catch (e) { return null; }
  }

  async function sendAddToWishlist(handle) {
    const p = await fetchProduct(handle);
    if (!p) return;

    const variant = (p.variants && p.variants[0]) || null;
    if (!variant) return;

    // Структура 1-в-1 як у доці eSputnik: AddToWishlist ПЛАСКИЙ, без обгортки Product.
    const payload = {
      AddToWishlist: {
        productKey: String(variant.id),   // == g:id у фіді (variant_id), збігається з ProductPage
        price: (p.price / 100).toFixed(2),
        isInStock: p.available ? 1 : 0,   // Int, як у документації
      },
    };

    // user_email/externalCustomerId — лише якщо тема їх виставила
    const gi = customerGeneralInfo();
    if (Object.keys(gi).length) payload.GeneralInfo = gi;

    try {
      // eS.js сам допише GeneralInfo (siteId, sc, webId, orgId, datetime, referrer, s_location)
      window.eS('sendEvent', 'AddToWishlist', payload);
    } catch (e) {
      console.warn('[eSputnik wishlist] send failed', e);
    }
  }

  /* ---- ловимо ДОДАВАННЯ через дифф списку (RemoveFromWishlist в eSputnik немає) ---- */
  function readList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  whenESReady(function () {
    let prev = readList();

    document.addEventListener('wishlist:change', function (e) {
      const now = (e.detail && e.detail.handles) || readList();
      const added = now.filter(function (h) { return prev.indexOf(h) === -1; });
      prev = now.slice();
      added.forEach(sendAddToWishlist);
    });
  });
})();